import React from 'react';
import { UiKit } from '@datavant/uikit';
import { VStack } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const DrChronoModal = (props: { onClose: () => void; isOpen: boolean }) => {
    const onClick = () => {
        const url =
            'https://support.healthjump.com/hc/en-us/articles/37113156328077-DrChrono-API-Datavant-Site-Connect-Activation-ROI';
        window.open(url, '_blank');
    };

    const ModalBody = (
        <VStack width={'100%'} alignItems={'left'} spacing={UiKit.consistency.extraLargeBuffer}>
            <UiKit.Text.BodyRegularBold>
                To continue AutoFulfill set up, please follow the steps outlined at the link below.
            </UiKit.Text.BodyRegularBold>
            <UiKit.Text.BodyRegular>
                Our team will reach out with next steps once we are ready to proceed with implementation.
                Please reach out to requestmanager@datavant.com with any questions.
            </UiKit.Text.BodyRegular>
        </VStack>
    );

    const ModalFooter = (
        <UiKit.Chakra.VStack>
            <UiKit.Chakra.HStack w={'full'} justifyContent={'flex-end'} spacing={UiKit.consistency.buffer}>
                <UiKit.Button.Cancel text={'Not Now'} onClick={props.onClose} />
                <UiKit.Button.Primary
                    text="Continue Set Up"
                    onClick={onClick}
                    rightIcon={<FontAwesomeIcon icon={UiKit.Icons.FontAwesome.solid.faArrowRight} />}
                />
            </UiKit.Chakra.HStack>
        </UiKit.Chakra.VStack>
    );

    return (
        <UiKit.Modal
            title={'Continue Autofulfill Set Up'}
            bodyFragment={ModalBody}
            footerFragment={ModalFooter}
            onClose={props.onClose}
            isOpen={props.isOpen}
            size={'2xl'}
            fullScreen={false}
        />
    );
};
